import React from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/default_boat.jpg?alt=media&token=b8c971f7-0a9b-4433-8516-ff0c7a3b7a7e';

export class TournamentNumsTv extends React.Component {
  
  constructor(props) {
    super(props);
		this.state = {
			teams: {},
			teamsNum: '',
			anglers:{},
			anglersNum: '',
			logs: [],
			speciesNums: [],
			speciesArray: []
		}
  }
  
  componentDidMount() {
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({teams: newProps.boats, anglers: newProps.anglerNums, logs: newProps.logs, species: newProps.species});
		this.getNumbers(newProps.boats, newProps.anglerNums);
		this.getSpeciesNums(newProps.species, newProps.logs);
  }
	
	getNumbers(boats, anglers){
			this.setState({
				teamsNum: Object.keys(boats).length,
				anglersNum: Object.keys(anglers).length
			})
	}
	
	getSpeciesNums(species, logs) {
		var speciesArray = [];
		species.forEach((specie) => {
			var specieLogs = [];
			logs.forEach((log) => {
				if(specie.id === log.speciesId) {
					specieLogs.push({
						log
					})
				}
			})
			speciesArray.push({
				specieName: specie.name,
				speciesImageUri: specie.speciesImageUri,
				logs: specieLogs
			})
		})
		this.setState({
			speciesArray
		})
	}
  
  render() {
		var settings = {
      dots: false,
      arrows: false,
      infinite: true,
			autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 6,
      slidesToScroll: 1,
      swipeToSlide: false,
    };
    return (
				<Slider {...settings}>
					{this.state.speciesArray.map((specie, i) => (
						<div className='speciesNumsTv' key={i}>
							<div id='anglerThm' 
								style={{
									position: 'relative',
									backgroundSize: 'contain',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: '50% 50%',
									width: '80%', 
									height: 70,
									marginTop: 5,
									marginBottom: 5,
									marginLeft: 'auto',
									marginRight: 'auto',
									backgroundImage: 'url(' +  specie.speciesImageUri  + ')'
								}}>
							</div>
							<div className='tnp-speciesBoxNumTv'>{specie.logs.length}</div>
						</div>
					))}
				</Slider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/ptc/comps/TournamentNumsTv.js